/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportedAiModelResponse
 */
export interface SupportedAiModelResponse {
    /**
     * 
     * @type {string}
     * @memberof SupportedAiModelResponse
     */
    modelId: string;
    /**
     * 
     * @type {string}
     * @memberof SupportedAiModelResponse
     */
    modelName: string;
}

/**
 * Check if a given object implements the SupportedAiModelResponse interface.
 */
export function instanceOfSupportedAiModelResponse(value: object): value is SupportedAiModelResponse {
    if (!('modelId' in value) || value['modelId'] === undefined) return false;
    if (!('modelName' in value) || value['modelName'] === undefined) return false;
    return true;
}

export function SupportedAiModelResponseFromJSON(json: any): SupportedAiModelResponse {
    return SupportedAiModelResponseFromJSONTyped(json, false);
}

export function SupportedAiModelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportedAiModelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'modelId': json['modelId'],
        'modelName': json['modelName'],
    };
}

export function SupportedAiModelResponseToJSON(json: any): SupportedAiModelResponse {
    return SupportedAiModelResponseToJSONTyped(json, false);
}

export function SupportedAiModelResponseToJSONTyped(value?: SupportedAiModelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'modelId': value['modelId'],
        'modelName': value['modelName'],
    };
}

